// §27 / §9.1 — Reminders as an in-process app.
//
// **Gated** (D-200), unlike Alarms: every list lives on the server and every share is a §26
// connection, so a guest has nothing to show and nowhere to put anything. §26.9's rule that a guest
// reaches none of the social layer covers this too.
//
// Not lazy, for the reason `apps/chat` is not: a `reminder` doorbell frame sends somebody here, and
// a chunk fetch between "somebody added a thing to our list" and seeing it is latency at the moment
// the feature exists for.
import type { InProcessApp, RemindersShellAccess } from '@hangar/shared';
import { createRoot, type Root } from 'react-dom/client';
import { Reminders } from './Reminders';

export function createRemindersApp(access: RemindersShellAccess): InProcessApp {
  const roots = new WeakMap<HTMLElement, Root>();
  return {
    id: 'reminders',
    name: 'Reminders',
    icon: { glyph: 'list-checks', hue: 32 },
    keywords: ['reminder', 'task', 'todo', 'list', 'checklist', 'shared', 'group'],
    requiresAuth: true,
    window: { width: 900, height: 600, minWidth: 520, minHeight: 360, multiWindow: false },
    mount(container) {
      const root = createRoot(container);
      roots.set(container, root);
      root.render(<Reminders access={access} />);
    },
    unmount(container) {
      const root = roots.get(container);
      roots.delete(container);
      root?.unmount();
    },
  };
}
